import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  CLEAR_CARGO_CORPORATE_CREDIT_CITIES,
  CLEAR_CARGO_CORPORATE_CREDIT_CITY,
  FLAG_CARGO_CORPORATE_CREDIT_CITY_ACTIVITY,
  FLAG_GETTING_CARGO_CORPORATE_CREDIT_CITIES,
  GET_CARGO_CORPORATE_CREDIT_CITIES,
  GET_CARGO_CORPORATE_CREDIT_CITY,
} from '../../../actions/types';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_CARGO_CORPORATE_CREDIT_CITIES:
      return state.setIn(['all', 'loading'], payload);
    case GET_CARGO_CORPORATE_CREDIT_CITIES:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_CARGO_CORPORATE_CREDIT_CITIES:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_CARGO_CORPORATE_CREDIT_CITY_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_CARGO_CORPORATE_CREDIT_CITY:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_CARGO_CORPORATE_CREDIT_CITY:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
